<template>
  <div>
	  <Header :sel='3' @changePhone="changePhone"/>
	  <!--neirong-->
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner">
	      <div class="banner_txt">
	        <p><strong>News Center</strong></p>
	        <p>新闻中心</p>
	      </div>
	    </div>
	    <!--banner--> 
	    
	    <!--neirong-->
	    <div class="neirong"> 
	      <!--left-->
	      
	      <div class="bread"> <a href="01 index.html">首页</a> - <a href="javascript:void(0)">新闻中心</a> - <a href="javascript:void(0)">公司新闻</a> - <a href="javascript:void(0)">{{detail.title}}</a></div>
	      <div class="neirong_c">
	          <div class="news_t">{{detail.title}}</div>
	          <div class="news_laiyuan"><span>{{detail.createBy}} / {{detail.createTime}}/ 品牌活动</span></div>
	          <div class="news_c" v-html="detail.cmsArticleData?detail.cmsArticleData.content:''"> 　
	         </div>
	        </div>
	    </div>
		 <Footer/>
		</div>
	  
	  
	  
	  <!--neirong--> 
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{articleDetail} from '@/api/reqFetch.js'
	import{LH} from '@/utils/util.js'
	
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			id:'',
			detail:{},
			showPhone:false
		}
  	},

  	mounted() {
	 this.id=this.$route.query.id
      this.getNewDetail();
  	},

  	methods: {
		changePhone(val){
			this.showPhone=val
		},
		getNewDetail(){
			articleDetail({id:this.id}).then(res => {
			    this.detail = res.data;
			});
		}
     
  	}
  }
</script>

<style scoped>/*内容*/
.banner{
	background-image: url('../../assets/images/banner_03.png');
}
</style>
